export const BOUGHT_BY_CLIENT_OUTSIDE_MAJOR = {
  value: "BOUGHT_BY_CLIENT_OUTSIDE_MAJOR",
  key: "clients.form.inactivationReasons.boughtByClientOutsideMajor",
};
export const BOUGHT_BY_MAJOR_CLIENT = {
  value: "BOUGHT_BY_MAJOR_CLIENT",
  key: "clients.form.inactivationReasons.boughtByMajorClient",
};
export const LEAVING_FOR_COMPETITOR = {
  value: "LEAVING_FOR_COMPETITOR",
  key: "clients.form.inactivationReasons.leavingForCompetitor",
};
export const NO_LONGER_OFFERS_GROUP_INSURANCE = {
  value: "NO_LONGER_OFFERS_GROUP_INSURANCE",
  key: "clients.form.inactivationReasons.noLongerOffersGroupInsurance",
};
export const ELIGIBILITY_CRITERIA_TOO_SMALL = {
  value: "ELIGIBILITY_CRITERIA_TOO_SMALL",
  key: "clients.form.inactivationReasons.eligibilityCriteriaTooSmall",
};
export const DEATH = {
  value: "DEATH",
  key: "clients.form.inactivationReasons.death",
};
export const BANKRUPTCY = {
  value: "BANKRUPTCY",
  key: "clients.form.inactivationReasons.bankruptcy",
};
export const OTHER = {
  value: "OTHER",
  key: "clients.form.inactivationReasons.other",
};
export default [
  BOUGHT_BY_CLIENT_OUTSIDE_MAJOR,
  BOUGHT_BY_MAJOR_CLIENT,
  LEAVING_FOR_COMPETITOR,
  NO_LONGER_OFFERS_GROUP_INSURANCE,
  ELIGIBILITY_CRITERIA_TOO_SMALL,
  DEATH,
  BANKRUPTCY,
  OTHER,
];



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/enums/inactivationReasonTypes.js